var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOptica(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "sun glass"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 32c-23.87 0-22.72-.3-24.42.86a4.94 4.94 0 0 0-1.84 2.28 3 3 0 0 1-5.48 0A5 5 0 0 0 24.61 32H3a1 1 0 0 0-1 1v3.06A1 1 0 0 0 3 37a2 2 0 0 1 2 2v5a11 11 0 0 0 11 11h3a11 11 0 0 0 11-11 2 2 0 0 1 4 0 11 11 0 0 0 11 11h3a11 11 0 0 0 11-11v-5a2 2 0 0 1 2-2 1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM26 44a7 7 0 0 1-7 7h-3a7 7 0 0 1-7-7v-6a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2zm29 0a7 7 0 0 1-7 7h-3a7 7 0 0 1-7-7v-6a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2z",
    fill: "#26a695",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 44a1 1 0 0 1-.71-1.71l4-4a1 1 0 0 1 1.42 1.42C12.34 44.08 12.56 44 12 44zM16 45a1 1 0 0 1-.71-1.71l2-2a1 1 0 0 1 1.42 1.42C16.53 44.89 16.54 45 16 45zM45 45a1 1 0 0 1-.71-1.71l2-2a1 1 0 0 1 1.42 1.42C45.53 44.89 45.54 45 45 45zM41 44a1 1 0 0 1-.71-1.71l4-4a1 1 0 0 1 1.42 1.42C41.34 44.08 41.56 44 41 44zM22 11v1a2 2 0 0 1-2 2h-4a2 2 0 0 0-1.91 1.42L9.61 30h-5c5.3-17.42 4.78-15.72 5.1-16.75A6 6 0 0 1 15.45 9H20a2 2 0 0 1 2 2zM59.39 30h-5L50 15.42A2 2 0 0 0 48 14h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h4.55a6 6 0 0 1 5.74 4.25c.3.97.09.31 5.1 16.75z",
    fill: "#26a695",
    "data-original": "#000000",
    className: ""
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOptica);
export default __webpack_public_path__ + "static/media/icon_optica.3f45737633ce2653ed5535e7e5f3dab3.svg";
export { ForwardRef as ReactComponent };